import { render, staticRenderFns } from "./QuestionEditorModal.vue?vue&type=template&id=2a06cd22&scoped=true&"
import script from "./QuestionEditorModal.vue?vue&type=script&lang=js&"
export * from "./QuestionEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionEditorModal.vue?vue&type=style&index=0&id=2a06cd22&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06cd22",
  null
  
)

export default component.exports